export default function getImagePath(uri) {
  uri = ("" + uri).replace("../images/clothing/", "");
  return ["/images/clothing/", uri].join("");
}
